<template>
  <v-dialog
    :value="value"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
    @input="$emit('input', $event)"
  >
    <v-card class="survey-preview-card" v-if="value">
      <DrawerToolbar title="Preview Mode" icon="mdi-eye" color="warning" @close="close" />
      <div style="padding-top: 100px">
        <SurveysPrivateV2
          v-if="surveyId != null"
          :key="surveyId"
          :surveyId="String(surveyId)"
          :preview="true"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import DrawerToolbar from "@/components/generic/DrawerToolbar.vue";
import SurveysPrivateV2 from "@/views/SurveysPrivateV2.vue";

export default {
  name: "SurveyPreviewDrawer",
  components: {
    DrawerToolbar,
    SurveysPrivateV2,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    surveyId: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.survey-preview-card {
  background-color: var(--v-lightGrey-base);
}
</style>
